import React, { useState, useEffect } from 'react';

interface IProps {
    first: string;
    second: string;
    onChoose: Function;
    chosen?: string;
}

enum ChosenOne {
    first = 1,
    second = 2
}

export function PasslyToggle(props: IProps) {
    const { first, second, onChoose, chosen } = props;
    const [chosenOne, setChosenOne] = useState<ChosenOne>(ChosenOne.first);

    const handleChoice = () => {
        const choice: ChosenOne = chosenOne === ChosenOne.first ? ChosenOne.second : ChosenOne.first;
        setChosenOne(choice);
        onChoose(choice === ChosenOne.first ? first : second);
    };

    const componentClasses = (): string => {
        let classes: string = 'passlyToggle';
        return classes += chosenOne === ChosenOne.first ? ' passlyToggle--first' : ' passlyToggle--second';
    };

    const optionClasses = (chosen: ChosenOne): string => {
        let classes: string = 'passlyToggle__option';
        return classes += chosenOne === chosen ? ' passlyToggle__option--chosen' : '';
    };

    useEffect(() => {
        if (chosen && chosen !== '') {
            switch (chosen) {
                case first:
                    setChosenOne(ChosenOne.first);
                    break;
                case second:
                    setChosenOne(ChosenOne.second);
                    break;
                default:
                    setChosenOne(ChosenOne.first);
                    break;
            }
        }
    }, [chosen, first, second]);

    return (
        <div
            className={componentClasses()}
            onClick={handleChoice}
        >
            <span className={optionClasses(ChosenOne.first)}>{first}</span>
            <span className={optionClasses(ChosenOne.second)}>{second}</span>
        </div>
    );
}
